/**
 * Retrieves the translation of text.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-i18n/
 */
import { __ } from '@wordpress/i18n';

/**
 * React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/packages/packages-block-editor/#useblockprops
 */
import { useBlockProps, InspectorControls } from '@wordpress/block-editor';
import { Panel, PanelBody, PanelRow, TextControl, ToggleControl, Button } from '@wordpress/components';
import Search from '../Search';


/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import '../index.css';

/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-edit-save/#edit
 *
 * @return {Element} Element to render.
 */
export default function Edit({ attributes, setAttributes }) {
	const { enabled, kosten, tijden, informatie } = attributes

	const date = new Date(seasonal_block.natuurijs_datum)
	const dateLong = date.toLocaleDateString('nl-NL', { year: "numeric", month: "long", day: "numeric" })
	const dateShort = date.toLocaleDateString('nl-NL', { year: "numeric", month: "short", day: "numeric" })

	return (
		<div {...useBlockProps()}>

			<InspectorControls>
				<Panel>

					<PanelBody>
						<PanelRow>
							Dit blok kan bewerkt worden in thema instellingen.
						</PanelRow>
						<PanelRow>
							<Button variant="link" href={seasonal_block.site_url + "/wp-admin/options-general.php?page=otweg_options&tab=tab6"} target="_blank">Settings</Button>
						</PanelRow>
					</PanelBody>


					{/* <PanelBody title="Settings">
						<PanelRow>
							<ToggleControl
								checked={enabled || false}
								label="Enable block"
								onChange={(enabled) => setAttributes({ enabled })}
							/>
						</PanelRow>
					</PanelBody>

					<PanelBody title="Entreekosten">


						<PanelRow>
							<TextControl
								label="Kosten leden"
								value={kosten?.leden || ""}
								onChange={leden => setAttributes({ kosten: { ...kosten, leden } })}
								type="text"
							/>
						</PanelRow>

						<PanelRow>
							<TextControl
								label="Kosten niet-leden"
								value={kosten?.niet_leden || ""}
								onChange={niet_leden => setAttributes({ kosten: { ...kosten, niet_leden } })}
								type="text"
							/>
						</PanelRow>

						<PanelRow>
							<Search
								label="Prijslijst pagina"
								attribute={kosten?.prijslijst}
								setAttribute={prijslijst => setAttributes({ kosten: { ...kosten, prijslijst } })}
							/>
						</PanelRow>


					</PanelBody>

					<PanelBody title="Openingstijden">


						<PanelRow>
							<TextControl
								label="Openings dag"
								value={tijden?.dag || ""}
								onChange={dag => setAttributes({ tijden: { ...tijden, dag } })}
								type="date"
							/>
						</PanelRow>


						<PanelRow>
							<ToggleControl
								checked={tijden?.ochtend || false}
								label="Ochtend open"
								onChange={ochtend => setAttributes({ tijden: { ...tijden, ochtend } })}
							/>
						</PanelRow>
						<PanelRow>
							<TextControl
								label="Ochtend opening"
								value={tijden?.ochtend_open || ""}
								onChange={ochtend_open => setAttributes({ tijden: { ...tijden, ochtend_open } })}
								type="time"
							/>
						</PanelRow>
						<PanelRow>
							<TextControl
								label="Ochtend sluiting"
								value={tijden?.ochtend_sluit || ""}
								onChange={ochtend_sluit => setAttributes({ tijden: { ...tijden, ochtend_sluit } })}
								type="time"
							/>
						</PanelRow>


						<PanelRow>
							<ToggleControl
								checked={tijden?.avond || false}
								label="Avond open"
								onChange={avond => setAttributes({ tijden: { ...tijden, avond } })}
							/>
						</PanelRow>
						<PanelRow>
							<TextControl
								label="Avond opening"
								value={tijden?.avond_open || ""}
								onChange={avond_open => setAttributes({ tijden: { ...tijden, avond_open } })}
								type="time"
							/>
						</PanelRow>
						<PanelRow>
							<TextControl
								label="Avond sluiting"
								value={tijden?.avond_sluit || ""}
								onChange={avond_sluit => setAttributes({ tijden: { ...tijden, avond_sluit } })}
								type="time"
							/>
						</PanelRow>


					</PanelBody>

					<PanelBody title="Informatie">

						<PanelRow>
							<Search
								label="Natuurijs informatie pagina"
								attribute={informatie}
								setAttribute={informatie => setAttributes({ informatie })}
							/>
						</PanelRow>

					</PanelBody> */}

				</Panel>
			</InspectorControls>

			<div className="flex justify-center mt-10 mb-10 [&_p]:text-o-blue [&_h1]:text-o-blue" style={{ opacity: seasonal_block.natuurijs_actief === "0" && "50%" }}>
				<div className="bg-o-yellow max-w-6xl overflow-hidden rounded-3xl lg:rounded-full flex flex-col lg:flex-row px-12 py-10 lg:py-5">

					<div className="flex flex-col-reverse lg:flex-row">
						<div>
							<h1 className="font-bold text-lg">Entreekosten</h1>
							<div className="grid grid-cols-2">
								<p>Leden</p>
								<p className="ml-5 flex justify-end lg:justify-start">
									{seasonal_block.kosten_leden || "prijs"}
									{/* {kosten?.leden || "prijs"} */}
								</p>
								<p>Niet-leden</p>
								<div className="ml-5 flex flex-row items-center justify-end lg:justify-start">
									<p>
										{seasonal_block.kosten_nietleden_kinderen || "v.a. prijs"}
									</p>
									<a className="bg-o-red text-white text-sm w-5 h-5 flex justify-center items-center ml-2 rounded-full hover:cursor-pointer hover:opacity-80 transition-all">?</a>
								</div>
							</div>
						</div>

						<div className="w-full lg:w-auto lg:h-full border-b-o-blue border-b-4 lg:border-l-o-blue lg:border-l-4 rounded-full my-7 lg:my-0 lg:mx-5"></div>

						<div>
							<h1 className="font-bold text-lg">
								Natuurijs {dateLong != "Invalid Date" && dateShort != "Invalid Date" ? <>(<div class="sm:hidden inline-block">{dateShort}</div><div class="sm:!inline-block hidden">{dateLong}</div>)</> : "-"}
							</h1>
							<div className="grid grid-cols-4 md:grid-cols-2">
								<p className='break-normal'>ochtend</p>
								<p className="ml-5 col-span-3 md:col-span-1 text-right lg:text-left">
									{seasonal_block.natuurijs_ochtend_open === "1" &&
										(seasonal_block.natuurijs_ochtend_openings_tijd || "--:--") + " - " + (seasonal_block.natuurijs_ochtend_sluitings_tijd || "--:--")
									}
									{seasonal_block.natuurijs_ochtend_open === "0" && "gesloten"}
								</p>
								<p>avond</p>
								<p className="ml-5 col-span-3 md:col-span-1 text-right lg:text-left">
									{seasonal_block.natuurijs_avond_open === "1" &&
										(seasonal_block.natuurijs_avond_openings_tijd || "--:--") + " - " + (seasonal_block.natuurijs_avond_sluitings_tijd || "--:--")
									}
									{seasonal_block.natuurijs_avond_open === "0" && "gesloten"}
								</p>
							</div>
						</div>
					</div>

					<div className="w-full lg:w-auto lg:h-full border-b-o-blue border-b-4 lg:border-l-o-blue lg:border-l-4 rounded-full my-7 lg:my-0 lg:mx-5"></div>

					<div className="flex items-center justify-center lg:justify-start">
						<a className="flex items-center bg-o-red text-white text-lg px-5 py-2 rounded-full hover:cursor-pointer hover:opacity-80 transition-all">
							Alle informatie
							<span>
								<svg className="w-6 h-6 ml-1" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
									<path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 12H5m14 0-4 4m4-4-4-4" />
								</svg>
							</span>
						</a>
					</div>

				</div>
			</div>
		</div>
	);
}
